import { Link } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import PageHeader, { PageHeaderProps } from '../../layout/page/PageHeader'

const NotImplemented = ({
    header,
    label,
    description,
}: {
    header: PageHeaderProps
    label: string | JSX.Element
    description?: string | JSX.Element
}) => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <>
            <PageHeader {...header} />
            <div
                className={`container-fluid bg-${
                    theme === 'dark' ? 'dark' : 'light'
                } text-${theme === 'dark' ? 'light' : 'dark'} p-5 shadow`}
            >
                <div
                    className={`bg-${theme === 'dark' ? 'dark' : 'light'} p-5`}
                >
                    <h3 className="display-6 fw-bold">
                        {label}
                    </h3>

                    {description && (
                        <>
                            <hr />
                            {description}
                        </>
                    )}

                    <Link className="btn btn-outline-primary" to={'/'}>
                        Dashboard
                    </Link>
                </div>
            </div>
        </>
    )
}

export default NotImplemented
